import appConfig from 'appConfig';

export const getBannerNotificationFeatureKeyDetails = async (featureFlagName) => {
  const featureKeyData = await fetch(`${appConfig.getHarnessAPIURL()}${appConfig.getHarnessWorkspaceID()}/${featureFlagName}`, {
    method: 'GET',
    headers: {
      Authorization: appConfig.getHarnessAdminKey(),
    },
  }).then((response) => response.json());
  return featureKeyData;
};